import { Sentry } from '@/lib/sentry'

type ReportLevel = 'fatal' | 'error' | 'warning'

type ReportSource = 'render' | 'react-query' | 'unhandled'

interface ReportErrorContext {
  source: ReportSource
  level?: ReportLevel
  componentStack?: string | null
}

export function reportError(error: unknown, context: ReportErrorContext): void {
  const tag = `[GlobalErrorBoundary:${context.source}]`

  if (import.meta.env.DEV) {
    console.error(tag, error, {
      level: context.level ?? 'error',
      componentStack: context.componentStack,
    })
    return
  }

  console.error(tag, error)

  Sentry.captureException(error, {
    level: context.level ?? 'error',
    tags: { source: context.source },
    contexts: {
      react: { componentStack: context.componentStack ?? null },
    },
  })
}
